import React, { useState } from 'react';
import analyticService from '../../../../services/analytics';
import { getClass } from '../../../../utils/component-helpers';

const Toggle = ({ category, label, items, updateDateToggle }) => {
  const [selectedToggle, setSelected] = useState(0);

  const changeToggle = index => {
    const updatedItems = items.map((option, idx) => {
      return { ...option, selected: idx === index };
    });
    analyticService.trackEvent(category, 'Execute', label);
    setSelected(index);
    updateDateToggle(updatedItems);
  };

  return (
    <div className="date-toggle">
      {items.map((item, index) => (
        <div
          key={index}
          onClick={() => changeToggle(index)}
          className={getClass('toggle-item', {
            selected: selectedToggle === index,
            left: !index,
            right: index,
          })}
        >
          {item.label}
        </div>
      ))}
    </div>
  );
};

export default Toggle;
